import {
  trackEvent,
  trackPageView,
} from '../../../shared/app/utils/uo-tracking.js'

export const trackSettingsView = () => trackPageView('SETTINGS_VIEW')

export const trackSettingsAccountDeleteClick = () =>
  trackEvent('SETTINGS_ACCOUNT_DELETE_CLICK')

/**
 * @param {{click_target: string}}
 * eventAttributes - Attributes to be passed to the trackEvent call
 * @returns {Promise<void>} The event has been sent.
 */
export const trackSettingsItemClick = (eventAttributes) =>
  trackEvent('SETTINGS_ITEM_CLICK', eventAttributes)

/**
 * @param {{ authenticated: boolean, click_target: string}} attributes - Required data for populating event attributes
 * eventAttributes - Attributes to be passed to the trackEvent call
 * @returns { Promise<void> } The event has been sent
 */
export const trackEmailSettingsLanguagePreferenceClick = (eventAttributes) =>
  trackEvent('PREFERENCE_CLICK', eventAttributes)
